import { registerPlugin } from '@capacitor/core'
import type { AppAuthPlugin } from './definitions'

const AppAuthCapacitor = registerPlugin<AppAuthPlugin>('AppAuth')

export { AppAuthCapacitor }
export type { AppAuthPlugin }
